import sanityClient from '@sanity/client';
import imageUrlBuilder from '@sanity/image-url';

export const client = sanityClient({
  projectId: 'nbpoabsq',
  dataset: 'production',
  apiVersion: '2022-11-04',
  useCdn: true,
  token: 'skjkEChcs4vtU5NUviiAr1PcioCAMKGcgYWd7TXtOT3zRHUBJXpdGFvObt3s8tRefo1FSg4KMyo9jBzOVA6ZQB0bOxBnGEYn65DQNI1XjnDdrvOaJHOYg7YdRixUv6LRhFVet2Nx4BYufRpeRaSbbOMLUU3SsRuyD2ujb7a96vO0Jh4V023N',
});

const builder = imageUrlBuilder(client);

export const urlFor = (source) => builder.image(source);